var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_903_44639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.944 2.634L12 0L4.056 2.634C3.45747 2.83242 2.93668 3.21438 2.5676 3.72563C2.19852 4.23689 1.99992 4.85144 2 5.482V11.991C2 19.515 11.2 23.67 11.594 23.843L11.948 24L12.316 23.878C12.711 23.747 22 20.568 22 11.991V5.482C22.0001 4.85144 21.8015 4.23689 21.4324 3.72563C21.0633 3.21438 20.5425 2.83242 19.944 2.634ZM13 19.052H11V17.052H13V19.052ZM13 15H11V5H13V15Z",
    fill: "#17282F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_903_44639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.15bd9c33108465c63cfb085a256ad16a.svg";
export { ForwardRef as ReactComponent };